var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9727 50.75C11.2447 50.75 0.0356445 39.5409 0.0356445 25.813C0.0356445 11.9591 11.2447 0.75 24.9727 0.75C38.7006 0.75 49.9097 11.9591 49.9097 25.687C50.0356 39.5409 38.8266 50.75 24.9727 50.75ZM19.9349 24.4276V27.4503H24.9727C24.7208 28.7097 23.4613 31.3545 19.9349 31.3545C16.9122 31.3545 14.3933 28.8356 14.3933 25.687C14.3933 22.5384 16.9122 20.0195 19.9349 20.0195C21.6981 20.0195 22.8316 20.7752 23.4613 21.4049L25.8543 19.012C24.3429 17.5006 22.3278 16.619 19.9349 16.619C15.0231 16.619 10.9928 20.6492 10.9928 25.5611C10.9928 30.4729 15.0231 34.5031 19.9349 34.5031C25.0986 34.5031 28.4991 30.8508 28.4991 25.813C28.4991 25.1832 28.3732 24.8054 28.3732 24.3016H19.9349V24.4276ZM39.0785 24.4276H36.5596V21.9087H34.0407V24.4276H31.5218V26.9465H34.0407V29.4654H36.5596V26.9465H39.0785V24.4276Z",
    fill: "#D83828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.265e5630c8b34ae5ca876cbb01adf3d9.svg";
export { ForwardRef as ReactComponent };